import _ from 'lodash';
import createjs from 'createjs-collection';
import preload from 'preload-js';

import * as fJS from './../cjsRoot/fJS';

export class cjsPoint {
  _id;
  _name;
  _regs;
  _listener = {};
  _alwaysShow;
  _idGroup;
  _idItem;
  _block;
  _container;
  _multibookType;

  constructor(obj) {
    this._multibookType = obj.stage._mixins.multibookType;
    this._container = new createjs.Container();
    this._container.name = this._name =
      typeof obj.name === 'string' ? obj.name : typeof obj.id === 'string' ? obj.id : 'point';
    this._container.id = this._id =
      typeof obj.id === 'string' ? obj.id : typeof obj.name === 'string' ? obj.name : 'point';
    this._container.x =
      (typeof obj.positions === 'object' && typeof obj.positions.pos === 'object' && fJS.isNumeric(obj.positions.pos.x)
        ? obj.positions.pos.x
        : obj.stage.defConfig.point.positions.pos.x) +
      (typeof obj.positions === 'object' &&
      typeof obj.positions.offset === 'object' &&
      fJS.isNumeric(obj.positions.offset.x)
        ? obj.positions.offset.x
        : obj.stage.defConfig.point.positions.offset.x);
    this._container.y =
      (typeof obj.positions === 'object' && typeof obj.positions.pos === 'object' && fJS.isNumeric(obj.positions.pos.y)
        ? obj.positions.pos.y
        : obj.stage.defConfig.point.positions.pos.y) +
      (typeof obj.positions === 'object' &&
      typeof obj.positions.offset === 'object' &&
      fJS.isNumeric(obj.positions.offset.y)
        ? obj.positions.offset.y
        : obj.stage.defConfig.point.positions.offset.y);

    this._container.visible =
      typeof obj.alwaysShow === 'boolean' ? obj.alwaysShow : obj.stage.defConfig.point.alwaysShow;

    if (typeof obj.color === 'string' && obj.color !== 'transparent') {
      this._createShape(obj);
    }

    if (typeof obj.image === 'object' && obj.image !== null) {
      this._createImage(obj);
    }

    this._alwaysShow = typeof obj.alwaysShow === 'boolean' ? obj.alwaysShow : obj.stage.defConfig.point.alwaysShow;
    this._regs = {
      regX:
        typeof obj.registrationPoint === 'object' &&
        obj.registrationPoint !== null &&
        fJS.isNumeric(obj.registrationPoint.x)
          ? obj.registrationPoint.x
          : obj.stage.defConfig.point.registrationPoint.x,
      regY:
        typeof obj.registrationPoint === 'object' &&
        obj.registrationPoint !== null &&
        fJS.isNumeric(obj.registrationPoint.y)
          ? obj.registrationPoint.y
          : obj.stage.defConfig.point.registrationPoint.y,
    };
    this._block = typeof obj.block === 'boolean' ? obj.block : obj.stage.defConfig.point.block;
    if (typeof obj.idGroup === 'string') this._idGroup = obj.idGroup;
    if (typeof obj.idItem === 'string') this._idItem = obj.idItem;
  }

  _createShape(obj) {
    let shape = new createjs.Shape();
    shape.graphics.beginFill(obj.color).drawCircle(0, 0, obj.positions.rad);
    shape.name = this._container.name;
    shape.id = this._container.id;
    shape.width = obj.positions.rad * 2;
    shape.height = obj.positions.rad * 2;

    this._container.addChild(shape);
  }

  _createImage(obj) {
    let test = obj.image.src.replace('static/games/', `games/`);
    if (!_.includes(test, `static/${this._multibookType}/games`)) {
      if (_.includes(test, 'games/page')) {
        obj.image.src = require(`__staticDir/${this._multibookType}/${test}`);
      }
    }

    let img = new Image(),
      self = this;
    img.src = obj.image.src;
    img.onload = function (e) {
      let bmp = new createjs.Bitmap(obj.image.src);
      bmp.id = self._container.id;
      bmp.x = -1 * (bmp.image.width / 2);
      bmp.y = -1 * (bmp.image.height / 2);
      self._container.addChild(bmp);
    };
  }

  setPosXYfromSetTo(obj, item) {
    switch (obj.setTo.toLowerCase()) {
      case 'left':
        obj.x = fJS.isNumeric(obj.x) ? obj.x : 0;
        obj.y = fJS.isNumeric(obj.y) ? obj.y : item.height / 2;
        break;
      case 'right':
        obj.x = fJS.isNumeric(obj.x) ? obj.x : item.width;
        obj.y = fJS.isNumeric(obj.y) ? obj.y : item.height / 2;
        break;
      case 'center':
        obj.x = fJS.isNumeric(obj.x) ? obj.x : item.width / 2;
        obj.y = fJS.isNumeric(obj.y) ? obj.y : item.height / 2;
        break;
      case 'top':
        obj.x = fJS.isNumeric(obj.x) ? obj.x : item.width / 2;
        obj.y = fJS.isNumeric(obj.y) ? obj.y : 0;
        break;
      case 'bottom':
        obj.x = fJS.isNumeric(obj.x) ? obj.x : item.width / 2;
        obj.y = fJS.isNumeric(obj.y) ? obj.y : item.height;
        break;
    }
  }

  findPoint(engine, point) {
    if (typeof engine !== 'object' || engine === null) engine = this;
    let ab = 0,
      indx = false;
    for (let i in engine.points) {
      if (typeof engine.points[i] !== 'object' || engine.points[i] === null) continue;
      let poi = engine.container.localToGlobal(engine.points[i].x, engine.points[i].y),
        mp = Math.sqrt(Math.pow(poi.x - point.x, 2) + Math.pow(poi.y - point.y, 2));

      if (ab === 0 || ab > mp) {
        ab = mp;
        indx = i;
      }
    }

    return indx;
  }

  get shape() {
    return this._container;
  }
  set shape(v) {
    this._container = v;
  }
  get block() {
    return this._block;
  }
  set block(v) {
    this._block = v;
  }
  get id() {
    return this._id;
  }
  get name() {
    return this._name;
  }
  get regs() {
    return this._regs;
  }
  get alwaysShow() {
    return this._alwaysShow;
  }
  get idGroup() {
    return this._idGroup;
  }
  get idItem() {
    return this._idItem;
  }

  set visible(v) {
    this._container.visible =
      this.alwaysShow === true ? true : typeof v === 'boolean' ? v : this._container.visible === true ? false : true;
  }
  get x() {
    return this._container.x;
  }
  set x(v) {
    this._container.x = v;
  }
  get y() {
    return this._container.y;
  }
  set y(v) {
    this._container.y = v;
  }
}
